module.exports = __webpack_public_path__ + "static/media/selena-gomez-lesb.c7d4eae2.jpg";